import gm from "./user"

export const GMReducers = {
  gm: gm.reducer
}
